/**
 * FeeNotice (Payment Tracking v2)
 *
 * Replaces the old in-form PaymentStep. Entry forms no longer collect payment
 * info — this just tells the user the fee and that they'll settle up after
 * submitting.
 */

const fmtMoney = (n: number) => (n % 1 === 0 ? String(n) : n.toFixed(2));

interface FeeNoticeProps {
  entryFee: number;
}

const FeeNotice = ({ entryFee }: FeeNoticeProps) => {
  if (!entryFee || entryFee <= 0) return null;
  return (
    <div className="border border-amber-300 bg-amber-50 rounded-xl p-4 my-4">
      <p className="text-amber-900 font-semibold text-sm m-0">
        💵 Entry fee: ${fmtMoney(entryFee)}
      </p>
      <p className="text-amber-800 text-sm mt-1 mb-0">
        Submit your picks first — your entry is saved either way. Right after
        submitting you'll get your pay code and one-tap payment links.
      </p>
    </div>
  );
};

export default FeeNotice;
